<template>
    <div class="menu-container" >
        <!-- トップアイコンとタイトル -->
        <div class="topIcon">
            <a href="/">
                <img src="@/assets/img/menu/SABA.png" alt="Logo" />
            </a>
        </div>
        <div class="topTitle">
            <a href="/">{{ siteTheme }}</a>
        </div>

        <!-- 横並びメニュー -->
        <div class="menu" v-if="menuItems && Array.isArray(menuItems)">
            <ul id="nav_list">
                <!-- AboutからGallery -->
                <li v-for="item in menuItems.filter(i => i.id >= 1 && i.id <= 3)" :key="item.id">
                    <a :href="item.link">{{ item.name }}</a>
                </li>
                <!-- Villa -->
                <li v-for="item in menuItems.filter(i => i.id === 4)" :key="item.id" class="li-menu_villa">
                    <a class="a-menu-villa" :href="item.link" target="_blank">{{ item.name }}</a>
                </li>
            </ul>
        </div>

        <!-- ハンバーガーメニュー -->
        <div id="hamburgerMenu" v-if="menuItems && Array.isArray(menuItems)">
            <div class="openbtn" @click="toggleMenu">
                <span></span>
                <span></span>
            </div>
            <transition name="accordion">
                <div class="accordion" v-if="isMenuOpen">
                    <ul>
                        <!-- Home -->
                        <li v-for="item in filteredHomeItems" :key="item.id">
                            <a :href="item.link">{{ item.name }}</a>
                        </li>
                        <!-- AboutからGallery -->
                        <li v-for="item in filteredAboutToGalleryItems" :key="item.id">
                            <a :href="item.link">{{ item.name }}</a>
                        </li>
                        <!-- Villa -->
                        <li v-for="item in filteredVillaItems" :key="item.id" class="accordion-li-villa">
                            <a :href="item.link" target="_blank">{{ item.name }}</a>
                        </li>
                    </ul>
                    <ul class="ul2">
                        <li class="li2"><a href="https://www.instagram.com/we.love.lucius.annaeus.seneca/"
                                target="_blank">Instagram</a></li>
                        <li class="li2"><a href="#">X</a></li>
                    </ul>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { handleError } from 'vue';

export default {
    name: "Menu",
    inject: ['siteTheme', 'menuItems',], // 親から提供されたデータを利用
    data() {
        return {
            isMenuOpen: false,
        };
    },
    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;

            const button = document.querySelector(".openbtn");
            if (this.isMenuOpen) {
                button.classList.add("active");
            } else {
                button.classList.remove("active");
            }
        },
    },
    computed: {
        filteredHomeItems() {
            return this.menuItems.filter((item) => item.id === 0);
        },
        filteredAboutToGalleryItems() {
            return this.menuItems.filter((item) => item.id >= 1 && item.id <= 3);
        },
        filteredVillaItems() {
            return this.menuItems.filter((item) => item.id === 4);
        },
    },
};
</script>

<style scoped>
/**************************/
/* コンテナ */
/**************************/

.menu-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 65px;
    z-index: 102;
    display: flex;
    align-items: center;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 1.0), rgba(255, 255, 255, 0.8));
    backdrop-filter: blur(7px);
    -webkit-backdrop-filter: blur(7px);
}

/* スマホ表示 */
@media screen and (max-width: 570px) {
    .menu-container {
        height: 50px;
    }

    .menu-container.fade-out,
    .menu-container.fade-in {
        /* スマホ表示時にはfade-outとfade-inの効果を無効化 */
        transform: translateY(0);
        height: 50px;
        transition: none;
    }
}





/**************************/
/* トップアイコンとテキスト   */
/**************************/

.topIcon {
    position: fixed;
    left: 7%;
    top: 22px;
    width: 130px;
    height: 50px;
    display: flex;
    display: -webkit-flex;
    display: -ms-flexbox;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-justify-content: center;
    cursor: pointer;
    z-index: 1;
    -webkit-tap-highlight-color: transparent;
    /* スマホでのタップ時のハイライトを無効化 */
}

.topIcon img {
    width: 128px;
    height: auto;
    object-fit: cover;
    filter: grayscale(70%);
    -webkit-filter: grayscale(70%);
    -moz-filter: grayscale(70%);
}

@media (hover: hover) {
    .topIcon img:hover {
        animation: poyon none;
        animation: purupuru 0.3s linear 0s infinite;
    }
}

@media (hover: none) {}

@keyframes purupuru {
    0% {
        transform: scale(1.0, 1.0) translate(0%, 0%);
        filter: drop-shadow(0px 3px 5px rgba(160, 160, 160, 0.3));
    }

    20% {
        transform: scale(1.0, 1.06) translate(-5%, -4%) skew(6deg, 0deg);
    }

    50% {
        transform: scale(1.0, 0.94) translate(5%, 4%) skew(-6deg, 0deg);
    }

    65% {
        transform: scale(1.0, 1.03) translate(2%, -2%) skew(-3deg, 0deg);
        filter: drop-shadow(0px 3px 5px rgba(160, 160, 160, 0.7));
    }

    80% {
        transform: scale(1.0, 0.97) translate(-2%, 2%) skew(3deg, 0deg);
    }

    100% {
        transform: scale(1.0, 1.0) translate(0%, 0%);
        filter: drop-shadow(0px 3px 5px rgba(160, 160, 160, 0.1));
    }
}

.topTitle {
    position: fixed;
    top: 25px;
    left: calc(7% + 150px);
    width: 150px;
    height: 50px;
    display: flex;
    cursor: pointer;
    z-index: 99;
    -webkit-tap-highlight-color: transparent;
    /* スマホでのタップ時のハイライトを無効化 */
}

.topTitle a {
    font-family: "ShipporiMinchoBold";
    color: #2e2e2e;
    text-decoration: none;
    white-space: nowrap;
    font-size: 13px;
    transition: color 0.2s ease-out;
}

.topTitle:hover a {
    color: #69b1a9;
}


/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 1024px) {
    .topIcon {
        scale: 0.8;
    }

    .topTitle {
        display: none;
    }
}

@media screen and (max-width: 570px) {
    .topIcon {
        top: 11px;
        left: -10px;
        scale: 0.65;
    }

    .topIcon img {
        filter: grayscale(30%);
    }

    .topTitle {
        display: none;
    }
}



/**************************/
/*  ハンバーガーメニュー      */
/**************************/

/* PCでは非表示にする */
@media screen and (min-width: 570px) {
    .openbtn {
        display: none;
    }
}

/* ボタン外側 */
.openbtn {
    position: fixed;
    top: 0px;
    right: 20px;
    width: 50px;
    height: 50px;
    cursor: pointer;
    z-index: 104;
    -webkit-tap-highlight-color: transparent;
    /* スマホでのタップ時のハイライトを無効化 */
}

/* ボタン内側 */
.openbtn span {
    display: inline-block;
    transition: all .4s;
    position: absolute;
    right: 13px;
    height: 2px;
    background-color: #718585;
}

.openbtn span:nth-of-type(1) {
    top: 22px;
    width: 50%;
}

.openbtn span:nth-of-type(2) {
    top: 29px;
    width: 30%;
}

/*activeクラスが付与されると線が回転して×に*/
.openbtn.active span:nth-of-type(1) {
    top: 20px;
    left: 16px;
    transform: translateY(6px) rotate(-45deg);
    width: 35%;
}

.openbtn.active span:nth-of-type(2) {
    top: 32px;
    left: 16px;
    transform: translateY(-6px) rotate(45deg);
    width: 35%;
}



/**********展開と折りたたみ部分**********/

/* 展開・折りたたみアニメーション */
.accordion-enter-active,
.accordion-leave-active {
    transition-timing-function: ease-in;
    transition: 0.6s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

.accordion-enter,
.accordion-leave-to {
    opacity: 0;
    transform: scale(0.8);
}

/* 展開部分 */
.accordion {
    position: fixed;
    width: 100%;
    height: 100dvh;
    top: 0;
    right: 0;
    z-index: 103;
}

/* 画像にオーバーレイ */
.accordion::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    animation: slideUp 0.3s forwards;
    animation-timing-function: ease-in;
    pointer-events: none;
    z-index: -1;
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(11.5px);
    -webkit-backdrop-filter: blur(11.5px);
}

@keyframes slideUp {
    0% {
        transform: translateY(130%) skewY(-10deg);
    }

    100% {
        transform: translateY(0) skewY(0);
    }
}

.accordion ul {
    padding-top: 15%;
    /* padding-left: 50%; */
    font-size: 20px;
    width: 100%;
}

.accordion li {
    list-style: none;
    line-height: 1;
    padding: 0.7rem;
    font-family: serif;
    writing-mode: initial;
    margin-bottom: 1rem;
    font-weight: bold;
}

.accordion a:hover {
    color: #69b1a9;
}

.accordion a {
    position: relative;
    padding-top: 2rem;
    padding-bottom: 2rem;
    padding-right: 50%;
    /* z-index: 7; */
    color: #e6f7f7;
    text-decoration: none;
    opacity: 0;
    animation: fadeIn 0.6s forwards;
    animation-timing-function: ease-out;
    animation-delay: 0.3s;
}

.accordion-li-villa a {
    color: #8d9696;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.accordion .ul2 {
    padding-top: 20%;
    /* padding-left: 20%; */
    font-size: 13px;
}

.accordion .li2 {
    list-style: none;
    line-height: 1;
    padding: 1rem;
    padding-bottom: 0rem;
    font-family: sans-serif;
    writing-mode: initial;
    font-weight: 400;
}




/****************************/
/*  横並びメニューのスタイル  */
/****************************/

.menu {
    position: fixed;
    top: 20px;
    right: 7%;
    font-family: sans-serif;
    writing-mode: initial;
    z-index: 1;
}

/*スマホでは非表示*/
@media (max-width: 570px) {
    .menu {
        display: none;
    }
}

.menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 13px;
}

.menu .li-menu_villa {
    margin-left: 20px;
    color: #ffffff;
}

.menu a {
    font-size: 13px;
    position: relative;
    display: block;
    padding: 5px 10px;
    color: #2e2e2e;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.3s ease-out;
}

.menu .a-menu-villa {
    font-size: 11px;
    padding: 5px 30px;
    border-radius: 20px;
    background-color: #003633;
    transition: background-color 0.5s ease-out;
    color: #ffffff;
}

.menu:hover a {
    opacity: 0.4;
    transition: opacity 0.3s ease-out;
}

.menu:hover .a-menu-villa {
    opacity: 1;
}

.menu a:hover {
    color: #69b1a9;
    opacity: 1;
}

.menu a.active {
    color: #69b1a9;
    transition: opacity 0.4s ease-out;
}

.menu .a-menu-villa:hover {
    color: #ffffff;
    background-color: #69b1a9;
    box-shadow: rgba(0, 202, 192, 0.2) 0px 2px 8px 0px;
}
</style>